const UPDATES = [
  {
    time: '10:42',
    title: '知名艺人片场争执画面曝光，剧组内部人士独家爆料拍摄现场真实内幕',
    tag: '娱乐',
    hot: true,
  },
  {
    time: '09:15',
    title: '某电商平台数据造假实锤？内部员工匿名提交关键证据引热议',
    tag: '电商',
    hot: true,
  },
  {
    time: '08:30',
    title: '热门综艺节目淘汰内幕流出，选手真实排名与播出顺序大不相同',
    tag: '综艺',
    hot: false,
  },
  {
    time: '07:48',
    title: '某品牌食品安全问题再添新料，供应商聊天记录截图曝光',
    tag: '消费',
    hot: true,
  },
  {
    time: '昨日 23:15',
    title: '科技圈大厂裁员真相揭秘，内部邮件透露真实原因并非业绩问题',
    tag: '科技',
    hot: false,
  },
  {
    time: '昨日 20:30',
    title: '某热门楼盘质量争议持续发酵，业主群内部讨论记录完整公开',
    tag: '房产',
    hot: false,
  },
  {
    time: '昨日 18:00',
    title: '网约车平台算法黑箱曝光，司机群体联合提供大量一手数据佐证',
    tag: '出行',
    hot: true,
  },
];

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="flex items-center justify-between mb-8">
          <div>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">最新快讯</h2>
            <p className="text-sm text-foreground-500 mt-2">实时追踪爆料大赛最新动态</p>
          </div>
          <a href="#" className="hidden sm:flex items-center text-sm text-primary-500 hover:text-primary-600 transition-colors whitespace-nowrap font-medium">
            查看全部 <i className="ri-arrow-right-line ml-1"></i>
          </a>
        </div>

        <div className="space-y-0">
          {UPDATES.map((item, i) => (
            <div
              key={i}
              className="group flex items-start gap-3 md:gap-4 py-4 border-b border-background-200/70 last:border-b-0 hover:bg-background-50/60 transition-colors rounded-lg px-3 -mx-3 cursor-pointer"
            >
              <span className="text-xs text-foreground-400 font-mono whitespace-nowrap pt-0.5 min-w-[50px]">
                {item.time}
              </span>
              <div className="min-w-0 flex-1">
                <p className="text-sm md:text-base text-foreground-800 group-hover:text-primary-600 transition-colors leading-relaxed">
                  {item.title}
                </p>
              </div>
              <div className="flex items-center gap-2 flex-shrink-0">
                {item.hot && (
                  <span className="inline-flex items-center px-1.5 py-0.5 rounded-full bg-accent-100 text-accent-600 text-[10px] font-semibold whitespace-nowrap">
                    <i className="ri-fire-line mr-0.5 text-[8px]"></i>热
                  </span>
                )}
                <span className="inline-flex px-2 py-0.5 rounded-full bg-secondary-100 text-secondary-700 text-[10px] font-medium whitespace-nowrap">
                  {item.tag}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}